import React from "react";
import siteLogo from "../../assets/logo.png";
import {  Link } from "react-router-dom";
const PublicHome = () => {
  return (
    <div className="loginPage">
      <nav className="navbar navbar-expand-lg navbar-dark bg-success">
        <Link to="/" className="navbar-brand">
          <img src={siteLogo} alt="site logo" width="120px" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link
                className="nav-link active login"
                to="/landingpage"
              >
                Login
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default PublicHome;
